export default "__VITE_ASSET__CDU7Dik1__"